/**
 * Created by jjing on 6/8/2017.
 */

import React, {Component} from 'react';
import {Form, Input, Row, Col, Button, Select} from 'antd';
import request from 'superagent';
import Constant, {PRODUCT_SHOW_NAME} from '../../commons/Constants'
import {Panel, Table} from 'react-bootstrap';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6}
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18}
    }
};

const VerifyResult = ({status, result, errorMsg}) => {
    if (status === Constant.STATUS.error) {
        return (
            <div className="alert alert-dismissible alert-danger">
                <span>{errorMsg ? errorMsg : 'Failed to verify'}</span>
            </div>
        );
    } else if (status === Constant.STATUS.done) {
        return (
            <div>
                <Panel header="Matched Policy" bsStyle="info" eventKey="1">
                    <Table fill>
                        <tbody>
                            <tr>
                                <td>Policy ID</td>
                                <td>{result.Match.policyid}</td>
                            </tr>
                            <tr>
                                <td>Priority</td>
                                <td>{result.Match.priority}</td>
                            </tr>
                            <tr>
                                <td>Product</td>
                                <td>{result.Match.products.map((product) => {
                                    if(PRODUCT_SHOW_NAME[product])
                                        return PRODUCT_SHOW_NAME[product];
                                    else
                                        return product;
                                })}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Panel>

                <Panel header="Current Build Information" bsStyle="info" eventKey="2">
                    {!result.Result ? "No update available."
                        :
                        <Table fill>
                            <tbody>
                                <tr>
                                    <td>Version</td>
                                    <td>{result.Result.version}</td>
                                </tr>
                                {
                                    result.Result.URL.https &&
                                <tr>
                                    <td>Path URL</td>
                                    <td>{result.Result.URL.https}</td>
                                </tr>
                                }
                                {result.Result.URL["container-registry"] &&
                                <tr>
                                    <td>Hostname</td>
                                    <td>{result.Result.URL["container-registry"]}</td>
                                </tr>
                                }
                                {(result.Result["credentials"] && result.Result["credentials"]["username"]) &&
                                <tr>
                                    <td>User Name</td>
                                    <td>{result.Result["credentials"]["username"]}</td>
                                </tr>
                                }
                            </tbody>
                        </Table>
                    }
                </Panel></div>)
    }
    return null;
}

class PolicyVerifyViewAntForm extends Component {

    constructor(props) {
        super(props);

        this.state = {status: Constant.STATUS.init, result: "", errorMsg: ""};
    }

    checkVersionFormat = (rule, value, callback) => {
        const form = this.props.form;
        const {products} = this.props;
        const productValue = form.getFieldValue('product');
        let hasError = false;

        if (productValue && value) {
            products.forEach((product) => {
                if (product.product === productValue) {
                    const exp = product.versionRegExp;
                    const isValid = new RegExp(exp).test(value);
                    if (!isValid) {
                        hasError = true;
                        callback("Version format error." + exp);
                    }
                }
            });
        }
        if (!hasError)
            callback();
    }

    save = (event) => {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({status: Constant.STATUS.trying});
                request.post('/api/policy/verify')
                    .query({urlPath: '/verify'})
                    .send(values)
                    .end((err, res) => {
                        if (!err) {
                            const result = res.body;
                            if (result.Match) {
                                this.setState({status: Constant.STATUS.done, result: result});
                                return;
                            }
                            this.setState({status: Constant.STATUS.error, errorMsg: "No matched policy exists."});
                        } else
                            this.setState({status: Constant.STATUS.error, errorMsg: err.message});
                    })
            }
        });
    }


    render = () => {
        let {status, result, errorMsg} = this.state;
        const {products, tenants} = this.props;
        const { getFieldDecorator, getFieldValue, validateFields } = this.props.form;

        return (
            <div className="page-tenant-detail">
                <div className="page-close" onClick={() => this.props.close()}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
                <div className='page-detail-title'>
                    <i className={'page-detail-graphic graphic-verify'}></i>
                    <div className='page-detail-info'>
                        <b>Verify Policy</b>
                    </div>
                </div>
                <div className="form-horizontal" style={{paddingLeft: "30px", paddingRight: "30px", maxWidth: "800px"}}>
                    <Form onSubmit={(e) => this.save(e)} className="ant-form-horizontal">
                        <FormItem
                            {...formItemLayout}
                            label="Product"
                        >
                            {getFieldDecorator('product', {
                                trigger: "onSelect",
                                rules: [{
                                    required: true, message: 'Please select a product!'
                                }]
                            })(
                                <Select placeholder="Select a product" onChange={() => {
                                    if(getFieldValue("version")){
                                        validateFields(['version'], {force: true});
                                    }
                                }}>
                                    {products.map((product) => {
                                        return <Option key={product.product}
                                                       value={product.product}>{PRODUCT_SHOW_NAME[product.product] ? PRODUCT_SHOW_NAME[product.product] : product.product}</Option>
                                    })}
                                </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Version"
                            hasFeedback
                        >
                            {getFieldDecorator('version', {
                                rules: [{
                                    required: true, message: 'Please input version number!'
                                }, {validator: this.checkVersionFormat}]
                            })(
                                <Input/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Tenant"
                            hasFeedback
                        >
                            {getFieldDecorator('tid', {
                                rules: [{
                                    required: true, message: 'Please select a tenant!'
                                }]
                            })(
                                <Select placeholder="Tenant List" showSearch
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {
                                        tenants.sort((t1, t2) => {
                                            return t1.companyName.toLowerCase() === t2.companyName.toLowerCase() ? 0 : (t1.companyName.toLowerCase() > t2.companyName.toLowerCase() ? 1 : -1);
                                        }).map((value) => {
                                            return <Option key={value.tenantId}
                                                           value={value.tenantId}>{value.companyName + " (" + value.tenantDomain + ")"}</Option>
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>

                        <VerifyResult status={status} result={result} errorMsg={errorMsg}/>

                        <br/>
                        <div className="ant-modal-footer" style={{padding: "10px 0"}}>
                            <Row>
                                <Col span="7" style={{"text-align": "left"}}>
                                    <Button type="primary" htmlType="submit" size="large"
                                            loading={status === Constant.STATUS.trying}>
                                        {status === Constant.STATUS.trying ? "Verifying..." : "Verify"}
                                    </Button>
                                    <Button size="large" htmlType="button" onClick={() => this.props.close()}>
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

class PolicyVerifyViewAnt extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    close = () => {
        this.props.onClose();
    }

    render = () => {
        const {products, tenants} = this.props;
        const FormWrap = Form.create({})(PolicyVerifyViewAntForm);

        return (
            <FormWrap products={products} tenants={tenants} close={this.close}/>
        );
    }
}


export default PolicyVerifyViewAnt;


// WEBPACK FOOTER //
// ./src/modules/policy/PolicyVerifyViewRAntd.js